<script setup lang="ts">
/** Commit SHA of this build ("dev" locally), inlined by Vite. */
const APP_VERSION = ((import.meta.env.VITE_APP_VERSION as string | undefined) ?? "dev").slice(0, 7);
// Contact + off-site links, visible without opening the AGB dialog.
import { CONTACT_EMAIL, EVENT_INFO_URL, PRIVACY_POLICY_URL } from "../siteLinks";
</script>

<template>
  <footer class="border-t border-slate-200 bg-white">
    <div
      class="mx-auto flex max-w-5xl flex-wrap items-center gap-x-5 gap-y-1 px-4 py-4 text-xs text-slate-500"
    >
      <span>
        <i18n-t keypath="buy.footer.contact" tag="span" scope="global">
          <template #email>
            <a
              :href="`mailto:${CONTACT_EMAIL}`"
              class="underline hover:text-slate-800"
            >{{ CONTACT_EMAIL }}</a>
          </template>
        </i18n-t>
      </span>
      <a
        :href="EVENT_INFO_URL"
        target="_blank"
        rel="noopener"
        class="underline hover:text-slate-800"
      >{{ $t("buy.footer.eventInfo") }}</a>
      <a
        :href="PRIVACY_POLICY_URL"
        target="_blank"
        rel="noopener"
        class="underline hover:text-slate-800"
      >{{ $t("buy.terms.privacyLinkLabel") }}</a>
      <!-- Build identity, muted: lets a support conversation establish which
           build a customer is on without them digging through devtools. -->
      <span class="ml-auto tabular-nums text-slate-400">{{ APP_VERSION }}</span>
    </div>
  </footer>
</template>
